export function pendo() {
    return {
        restrict: 'E',
        templateUrl: '/asset/partials/angular-utilities/directives/pendo.html',
        controller: [() => {}],
    };
}
